import React from 'react';

export const ContactFormContext = React.createContext({});
